export const CONNECTOR_RIPPLE_SEGMENTS = 256;
